
            const data = {"name":"fold","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M10 16.039a2 2 0 0 0-2-2H4a1 1 0 1 0 0 2h4v4a1 1 0 1 0 2 0v-4ZM20 9.962a1 1 0 1 0 0-2h-4v-4a1 1 0 1 0-2 0v4a2 2 0 0 0 2 2h4Z\" _fill=\"#81889B\"/>","originalColors":[{"type":"fill","color":"#81889B"}],"stopColors":[]}}
        
                    module.exports = data
                    